import React from "react"
import clsx from "clsx"
import {Link} from "react-router-dom"
import {PlusSmallIcon} from "@heroicons/react/20/solid"

type CardProps = {
    title?: string | React.ReactNode,
    badge?: React.ReactNode,
    subTitle?: string
    footer?: string | React.ReactNode,
    bodyClassName?: string,
    footerClassName?: string,
    children?: string | React.ReactNode,
    search?: React.ReactNode,
    btnProps?: {
        icon?: React.ReactNode,
        text: string
    },
    actions?: React.ReactNode
}

export function Card({
                         title,
                         badge,
                         subTitle,
                         footer,
                         bodyClassName = "px-4 py-5 sm:px-6",
                         footerClassName,
                         search,
                         btnProps,
                         actions,
                         children
                     }: CardProps) {
    return (
        <div className="divide-y divide-gray-200 rounded-lg bg-white shadow">
            <div className="px-4 py-5 sm:px-6 flex flex-wrap justify-between items-center gap-6 sm:flex-nowrap">
                <div className="flex justify-start items-center gap-4">
                    <div>
                        <div className="flex items-center justify-start space-x-2">
                            <h2 className="text-base font-semibold leading-7 text-gray-900">{title}</h2>
                            {badge}
                        </div>
                        {subTitle && <span className="text-gray-500 text-sm">{subTitle}</span>}
                    </div>

                    {search &&
                      <div
                        className="order-last flex gap-x-8 sm:order-none sm:w-auto sm:border-l sm:border-gray-200 sm:pl-4 sm:leading-7">
                          {search}
                      </div>}
                </div>

                {btnProps &&
                  <Link
                    to={"create"}
                    className="ml-auto flex items-center gap-x-1 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                      {btnProps.icon ||
                        <PlusSmallIcon className="-ml-1.5 h-5 w-5" aria-hidden="true"/>}
                      {btnProps.text}
                  </Link>}
                {actions}
            </div>
            {/*{title &&*/}
            {/*  <div className="px-4 py-5 sm:px-6">*/}
            {/*      {typeof title === "string" ?*/}
            {/*          <h2 className="text-base font-semibold leading-7 text-gray-900">{title}</h2>*/}
            {/*          : title}*/}
            {/*  </div>}*/}
            {children &&
              <div className={bodyClassName}>{children}</div>}
            {footer &&
              <div className={clsx("px-4 py-4 sm:px-6", footerClassName)}>
                  {footer}
              </div>}
        </div>
    )
}
